import { DesignSystems } from "./DesignSystems";
import "./index.css";

export function App() {
  return (
    <DesignSystems />
  );
}

export default App;
